import increaseColorPointByRatio from '../../../../../common/utils/increase-color-point-by-ratio';

const light = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'secondaryButton.brandedSolid.background.default.light',
    params,
  };
  return increaseColorPointByRatio(
    {
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    },
    '50'
  );
};

export default light;
